import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import VoipResetPasswordForm from '../forms/VoipResetPasswordForm'
import FormSuccess from '../components/FormSuccess'
import store from '../store'
import globals from '../globals'
import { connect } from 'react-redux'

class ResetPasswordVoip extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            showSuccess: false,
            username: '',
            proxyServer: ''
        }
    }

    componentDidMount () {
        this.getData()
    }

    getData () {
        DataSource.getData(`/api/getService/voip/${this.props.serviceId}`, result => {
            this.setState({
                username: result.serviceDetails.username,
                proxyServer: result.serviceDetails.proxyServer,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleVerificationSuccess () {
        this.setState({ showSuccess: true })
        setTimeout(() => {
            this.setState({ showSuccess: false })
        }, 5000)
    }

    render () {
        const SuccessMsg = <FormSuccess icon={false} message='Success! You can now edit your details above.' />

        return (
            <div className='reset-password module'>
                <Heading title={this.props.title} />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>Forgotten your VoIP service password? If you need a new password to configure the VoIP service on your modem, you can unlock the form below and your new VoIP password will be temporarily displayed. It will remain displayed until you log out of My Exetel.</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <VoipResetPasswordForm
                                serviceId={this.props.serviceId}
                                showSuccess={this.state.showSuccess}
                                isVerified={this.props.isVerified}
                                username={this.state.username}
                                proxyServer={this.state.proxyServer}
                                handleVerificationSuccess={this.handleVerificationSuccess.bind(this)}
                                handleSuccess={() => globals.pushEvent('VoipResetPassword')}
                            />
                            {this.state.showSuccess ? SuccessMsg : ''}
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isVerified: state.verifiedUser.isVerified,
    verifiedToken: state.verifiedUser.verifiedToken
})

export default connect(mapStateToProps)(ResetPasswordVoip)



// WEBPACK FOOTER //
// ./resources/js/modules/ResetPasswordVoip.js